module.exports = __webpack_public_path__ + "img/cszq_partners_10.96ebb9b2.jpg";